import { FormattedMessage } from 'react-intl';
import { ReactNode } from 'react';

import { PoolSelect } from '../../select';
import { useFilter } from '../context';

interface BooleanFilterProps {
    filterName: string;
    labelTranslationId: string;
}

export const BooleanFilter = ({ filterName, labelTranslationId }: BooleanFilterProps) => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const BonusValues = ['true', 'false'];

    const onSelected = (value?: string) => {
        filter.delete(filterName);

        if (value) {
            filter.set(filterName, value);
        }

        updateFilter(filter);
    };

    const getDisplayValue = (statusValue: unknown): ReactNode => {
        if (typeof statusValue !== 'string') {
            return '';
        }

        return statusValue === 'true' ? (
            <FormattedMessage id="app.common.yes" />
        ) : (
            <FormattedMessage id="app.common.no" />
        );
    };

    registerFilterMap(filterName, getDisplayValue);

    return (
        <PoolSelect
            displayEmpty={true}
            name={filterName}
            label={<FormattedMessage id={labelTranslationId} />}
            fullWidth={true}
            value={filter.get(filterName)}
            onValueChange={onSelected}
            noSorting={true}
            options={BonusValues.map(value => {
                return {
                    value: value,
                    displayValue:
                        value === 'true' ? (
                            <FormattedMessage id="app.common.yes" />
                        ) : (
                            <FormattedMessage id="app.common.no" />
                        ),
                };
            })}
        />
    );
};
